import { z } from 'zod';
import { baseClaimSchema } from './baseClaim';
import { tariffSchema } from './tariff';

/** Local calendar date assigned to claims needing manual service-date review. */
export const MANUAL_REVIEW_SERVICE_DATE = '1990-01-01';

export const bulkClaimEditValuesSchema = baseClaimSchema
  .pick({
    serviceStart: true,
    serviceEnd: true,
    payorID: true,
    providerID: true,
    groupID: true,
    locationOfService: true,
    serviceLocationIndicator: true,
    hospitalCode: true,
    patientCount: true,
    virtualPhysicianRegion: true,
    thirdPartyLiability: true,
    optometristReason: true,
    incorporated: true,
    interpretingRadiologist: true,
    chiroService: true,
    facilityNumber: true,
    providerNotes: true,
    providerComments: true,
    clerkComments: true,
    referringProvider: true,
    icd9: true,
  })
  .extend({
    internalComments: z.string().optional().nullable(),
    tariffs: tariffSchema.array().min(1).optional(),
    intakeItemID: z.guid().optional(),
  })
  .partial()
  .refine((values) => Object.keys(values).length > 0, {
    message: 'At least one value is required for a bulk claim edit',
  });

export const bulkClaimEditSchema = z
  .object({
    claimIDs: z.array(z.guid()).min(1),
    values: bulkClaimEditValuesSchema,
  })
  .strict();

export type BulkClaimEditValues = z.input<typeof bulkClaimEditValuesSchema>;
export type BulkClaimEditInput = z.input<typeof bulkClaimEditSchema>;
export type BulkClaimEdit = z.infer<typeof bulkClaimEditSchema>;
